import { Box } from '@mui/material';
import netcare_logo from '../../assets/client_logos/netcare-logo.webp';
import cch_logo from '../../assets/client_logos/cch-logo.webp';
import vkb_logo from '../../assets/client_logos/vkb-logo.webp';
import sovereign_foods_logo from '../../assets/client_logos/sovereign-foods-logo.webp';
import southpoint_logo from '../../assets/client_logos/southpoint-logo.svg';
import lactalis_logo from '../../assets/client_logos/lactalis-logo.webp';
import pepkor_logo from '../../assets/client_logos/pepkor-logo.webp';
import du_toit_logo from '../../assets/client_logos/du-toit-logo.webp';
import koelenhof_logo from '../../assets/client_logos/koelenhof-logo.webp';
import InfiniteCarousel from '../shared/carousel/InfiniteCarousel';

interface ClientLogo {
  src: string;
  name: string;
}

/**
 * Section listing key client logos of EP Sustainability.
 * @returns {JSX.Element}
 */
const ClientLogosSection = () => {
  const client_logos: Array<ClientLogo> = [
    {
      src: netcare_logo,
      name: 'Netcare'
    },
    {
      src: cch_logo,
      name: 'CCH'
    },
    {
      src: vkb_logo,
      name: 'VKB'
    },
    {
      src: sovereign_foods_logo,
      name: 'Sovereign Foods'
    },
    {
      src: southpoint_logo,
      name: 'Southpoint'
    },
    {
      src: lactalis_logo,
      name: 'Lactalis'
    },
    {
      src: pepkor_logo,
      name: 'Pepkor'
    },
    {
      src: du_toit_logo,
      name: 'Du Toit'
    },
    {
      src: koelenhof_logo,
      name: 'Koelenhof'
    }
  ];

  const logos_to_render: Array<JSX.Element> = client_logos.map(
    (logo: ClientLogo, index: number) => (
      <Box
        key={`${logo.name}-${index}`}
        sx={{
          px: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img src={logo.src} alt={logo.name} style={{ height: '80px', objectFit: 'contain' }} />
      </Box>
    )
  );

  return (
    <Box id="clients" sx={{ py: 4 }}>
      <InfiniteCarousel width={'100%'} animation_duration={20} items={logos_to_render} />
    </Box>
  );
};

export default ClientLogosSection;
